
import Vue from 'vue';

const ChatEventBus = new Vue();

export default ChatEventBus;